/**
 * @generated SignedSource<<b74dcf07c76f428fadc277c7af55376b>>
 * @relayHash be53943df43514309a4d7c908c1c0fa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useSpaceHomepageIdSpaceHomepageIdQuery$variables = {
  spaceKey?: string | null | undefined;
};
export type useSpaceHomepageIdSpaceHomepageIdQuery$data = {
  readonly space: {
    readonly homepage: {
      readonly id: string | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type useSpaceHomepageIdSpaceHomepageIdQuery = {
  response: useSpaceHomepageIdSpaceHomepageIdQuery$data;
  variables: useSpaceHomepageIdSpaceHomepageIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ]
      },
      (v1/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "be53943df43514309a4d7c908c1c0fa2",
    "id": "7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5",
    "metadata": {},
    "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
    "operationKind": "query",
    "text": "query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id},id}}"
  }
};
})();

(node as any).hash = "008609f21691e19f9c101d43e2e78e81";

export default node;
